<script setup>
import { onMounted, onBeforeUnmount } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

onMounted(() => {
	const mask = document.querySelector('.not-just-mask__elem-body_mask')

	if (mask) {
		const isMobile = window.innerWidth <= 991.98
		const startHeight = isMobile ? '25.3rem' : '66rem'
		const endHeight = isMobile ? '100rem' : '200rem'

		let animationActive = false // флаг для контроля анимации

		ScrollTrigger.create({
			trigger: '.not-just-mask',
			start: 'top top',
			end: 'bottom-=20% top',
			scrub: true,
			// markers: true,
			onEnter: () => {
				// Запускаем scrub только если анимация ещё не была активна
				if (!animationActive) {
					animationActive = true
					gsap.set(mask, { height: startHeight })
				}
			},
			onUpdate: (self) => {
				if (animationActive) {
					gsap.to(mask, {
						height: gsap.utils.interpolate(startHeight, endHeight, self.progress),
						duration: 0,
					})
				}
			},
			onLeave: () => {
				// когда дошли до конца — плавный возврат
				gsap.to(mask, {
					height: startHeight,
					duration: 1,
					ease: 'power2.out',
					onComplete: () => {
						animationActive = false // сбрасываем флаг, чтобы следующий заход сверху сработал
					},
				})
			},
			onLeaveBack: () => {
				// при выходе вверх сбрасываем только если анимация не активна
				if (!animationActive) {
					gsap.set(mask, { height: startHeight })
				}
			},
		})
	}
})

onBeforeUnmount(() => {
	ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
})
</script>

<template>
	<section class="not-just-mask">
		<div class="not-just-mask__container">
			<div class="not-just-mask__content">
				<h1 class="not-just-mask__title-1">
					Это не <br />
					просто маска
				</h1>
				<h2 class="not-just-mask__title-2">
					<span>Это ты</span>
					<svg>
						<use href="#line" />
					</svg>
					<span>другой</span>
				</h2>

				<div class="not-just-mask__elem not-just-mask__elem-photos">
					<img
						loading="lazy"
						src="@/assets/img/not-just-mask/not-just-mask_img-2.png"
						alt=""
					/>
				</div>

				<div class="not-just-mask__elem not-just-mask__elem-body">
					<div class="not-just-mask__elem-body_bg">
						<picture>
							<source
								srcset="@/assets/img/not-just-mask/not-just-mask_img-1.png"
								media="(min-width: 991.98px)"
							/>
							<img
								src="@/assets/img/not-just-mask/not-just-mask_img-1--min.png"
								alt=""
							/>
						</picture>
					</div>
					<div class="not-just-mask__elem not-just-mask__elem-body_mask">
						<img
							loading="lazy"
							src="@/assets/img/not-just-mask/not-just-mask_img-4.png"
							alt=""
						/>
					</div>
				</div>

				<div class="not-just-mask__elem not-just-mask__elem-mask">
					<img
						loading="lazy"
						src="@/assets/img/not-just-mask/not-just-mask_img-5.png"
						alt=""
					/>
				</div>

				<div class="not-just-mask__elem not-just-mask__elem-man">
					<picture>
						<source
							srcset="@/assets/img/not-just-mask/not-just-mask_img-3.png"
							media="(min-width: 991.98px)"
						/>
						<img
							loading="lazy"
							src="@/assets/img/not-just-mask/not-just-mask_img-3--min.png"
							alt=""
						/>
					</picture>
				</div>
			</div>
		</div>
	</section>
</template>

<style lang="scss" scoped>
.not-just-mask {
	background-image: url('@/assets/img/page_bg-primary.jpg');
	background-position: top center;
	background-size: cover;
	height: 103.1rem;
	padding: 6.7rem 0 0;
	position: relative;
	color: #101010;
	z-index: 10;

	@media (max-width: 991.98px) {
		height: 76.3rem;
		padding-top: 1.8rem;
	}

	// .not-just-mask__container
	&__container {
		height: 100%;
	}

	// .not-just-mask__content
	&__content {
		position: relative;
		height: 100%;

		@media (max-width: 991.98px) {
			max-width: 36rem;
			margin: 0 auto;
		}
	}

	// .not-just-mask__elem
	&__elem {
		position: absolute;
		pointer-events: none;
		user-select: none;

		img {
			width: 100%;
			object-fit: contain;
		}
	}

	// .not-just-mask__elem-title-1
	&__title-1 {
		z-index: 4;
		position: relative;

		@media (min-width: 991.98px) {
			width: 49.7rem;

			br {
				display: none;
			}
		}

		@media (max-width: 991.98px) {
			text-align: center;
		}
	}

	// .not-just-mask__elem-title-2
	&__title-2 {
		display: flex;
		align-items: center;
		transform: rotate(-6deg);
		position: relative;
		z-index: 4;

		@media (min-width: 991.98px) {
			position: absolute;
			top: 3rem;
			right: 11.1rem;
		}

		@media (max-width: 991.98px) {
			justify-content: center;
			margin-top: 2rem;
			transform: rotate(-3.5deg);
		}

		span {
			color: inherit;
		}

		svg {
			height: 6.5rem;
			width: 6.5rem;
			margin: 0 2.4rem -2rem;
			transform: rotate(6deg);

			@media (max-width: 991.98px) {
				width: 2.5rem;
				height: 2.5rem;
				margin: 0 1rem -1rem;
			}
		}
	}

	// .not-just-mask__elem-mask
	&__elem-mask {
		bottom: 10.6rem;
		left: 5.8rem;
		width: 34.2rem;
		z-index: 3;

		@media (max-width: 991.98px) {
			width: 11.7rem;
			top: 28.8rem;
			right: 0rem;
			bottom: auto;
			left: auto;
		}
	}

	// .not-just-mask__elem-photos
	&__elem-photos {
		@media (min-width: 991.98px) {
			top: 14.8rem;
			right: -1.3rem;
			width: 71.6rem;
			z-index: 0;
		}

		@media (max-width: 991.98px) {
			position: relative;
			margin-top: 3.1rem;
			width: 105%;
		}
	}

	// .not-just-mask__elem-man
	&__elem-man {
		right: -1.2rem;
		bottom: 0;
		width: 69.3rem;
		z-index: 1;

		@media (max-width: 991.98px) {
			width: 28.6rem;
			right: -6.6rem;
			bottom: 5.2rem;
		}
	}

	// .not-just-mask__elem-body
	&__elem-body {
		left: 11rem;
		bottom: 0;
		z-index: 2;
		width: 112.6rem;

		@media (max-width: 991.98px) {
			width: 45rem;
			left: auto;
			bottom: 0;
			right: 1.6rem;
		}

		// .not-just-mask__elem-body_bg
		&_bg {
		}

		// .not-just-mask__elem-body_mask
		&_mask {
			z-index: 1;
			top: 2.1rem;
			left: 52.8%;
			transform: translateX(-50%);
			width: 44.5rem;
			height: 66rem;

			@media (max-width: 991.98px) {
				top: 3.1rem;
				left: 52.3%;
				width: 17.2rem;
				height: 25.3rem;
			}

			img {
				height: 100%;
				object-fit: unset;
			}
		}
	}
}
</style>
